import React, { useState } from 'react';
import { propTypes, withFormsy } from 'formsy-react';
import styled from 'styled-components';

const InputWrap = styled.div`
  width: 100%;
  margin-bottom: 20px;
  label {
    color: #74777E;
    margin-bottom: 10px;
  }

  input {
    width: 100%;
    padding: 20px 24px;
    background-color: #EEEFF2;
    border-radius: 16px;
    ::placeholder {
      color: #AEAEAE;
      font-size: 14px;
      line-height: 20px;
    }
  }
`

const NoticeMessage = styled.span`
  color: #FF6E30;
  font-size: 12px;
  margin-top: 10px;
  line-height: 16px;
`

const ErrorMessage = styled.span`
  color: #FF6E30;
  font-size: 12px;
  line-height: 16px;
  margin-top: 10px;
`

const Input = ({title, placeholder, type, errorMessage, noticeMessage}) => {
  const [value, setValue] = useState(null);

  return (
    <InputWrap>
      <label>
        {title}
      </label>
      <input
        type={type}
        placeholder={placeholder}
      />
      {errorMessage && (
        <ErrorMessage>{errorMessage}</ErrorMessage>
      )}
      {noticeMessage && (
        <NoticeMessage>{noticeMessage}</NoticeMessage>
      )}
    </InputWrap>
  )
}

Input.propTypes = {
  ...propTypes,
};

export default withFormsy(Input);